(function () {
  const tabs = document.querySelector('[data-sp-catalog-tabs]');
  const coleccionTabs = document.querySelector('[data-sp-coleccion-tabs]');
  const grid = document.querySelector('[data-sp-catalog-grid]');
  if (!grid) return;

  const buttons = tabs ? tabs.querySelectorAll('[data-sp-category]') : [];
  const coleccionButtons = coleccionTabs ? coleccionTabs.querySelectorAll('[data-sp-coleccion]') : [];
  const items = grid.querySelectorAll('.grid__item[data-sp-category]');
  const params = new URLSearchParams(window.location.search);
  const coleccionParam = params.get('coleccion');
  const emptyState = document.querySelector('[data-sp-catalog-empty]');

  function updateEmptyState() {
    if (!emptyState) return;
    const visible = Array.from(items).some((item) => !item.classList.contains('is-hidden'));
    emptyState.hidden = visible;
  }

  function setCategoryActive(category) {
    if (!tabs) return;
    buttons.forEach((btn) => {
      btn.classList.toggle('is-active', btn.dataset.spCategory === category);
    });
    items.forEach((item) => {
      const match = category === 'all' || item.dataset.spCategory === category;
      item.classList.toggle('is-hidden', !match);
    });
    updateEmptyState();
  }

  function setColeccionActive(line) {
    coleccionButtons.forEach((btn) => {
      btn.classList.toggle('is-active', btn.dataset.spColeccion === line);
    });

    items.forEach((item) => {
      if (line === 'all') {
        item.classList.remove('is-hidden');
        return;
      }

      const lines = (item.dataset.spLine || '').split(/\s+/).filter(Boolean);
      const match = line === 'sale' ? lines.includes('sale') : lines.includes(line);
      item.classList.toggle('is-hidden', !match);
    });

    updateEmptyState();
  }

  if (tabs) {
    buttons.forEach((btn) => {
      btn.addEventListener('click', () => setCategoryActive(btn.dataset.spCategory));
    });
  }

  if (coleccionTabs) {
    coleccionButtons.forEach((btn) => {
      btn.addEventListener('click', () => setColeccionActive(btn.dataset.spColeccion));
    });

    setColeccionActive(coleccionParam || 'all');
    return;
  }

  if (coleccionParam) {
    setColeccionActive(coleccionParam);
  } else {
    const category = params.get('category');
    if (category) setCategoryActive(category);
  }
})();
